import {Injector} from '@angular/core';

export class AttributeNotFoundError implements Error {
  name = 'DialogConfiguration.AttributeNotFound';
  message = '1 | An attribute was not found.';

  constructor(
    private resource: string,
    private attribute: string,
  ) {
    this.message =
      "1 | Could not find attribute '" +
      attribute +
      "' for resource '" +
      resource +
      "'. Check attribute bindings.";
  }
}

export class ControlNameNotFound implements Error {
  name = 'DialogConfiguration.ControlNameNotFound';
  message = '2 | Could not get name of the control.';

  constructor() {}
}

export class NestedObjectUpdateError implements Error {
  name = 'DialogConfiguration.NestedObjectUpdate';
  message = '3 | Update of nested object invalid.';

  constructor(
    private reference: string,
    private attribute: string,
  ) {
    this.message =
      "3 | Update of attribute '" +
      attribute +
      "' for reference '" +
      reference +
      "' invalid. Check properties, nested object bindings are read only.";
  }
}

export class InvalidItemSourceObjectError implements Error {
  name = 'DialogConfiguration.InvalidItemSourceObject';
  message =
    '4 | ItemSource property is invalid, BindingPath must be an object type. Caption-, Value- and HintPaths must be valid attributes or default values.';

  constructor(
    private bindingpath: string,
    private attributes: string,
  ) {
    this.message =
      "4 | ItemSource property is invalid. BindingPath '" +
      bindingpath +
      "' must be an object type or attributes '" +
      attributes +
      "' are invalid. Check attribute bindings.";
  }
}

export class DialogConfigurationNotFoundError implements Error {
  name = 'View.DialogConfigurationNotFoundError';
  message = '5 | Dialog Configuration not found.';

  constructor(private objecttype: string) {
    this.message = "5 | Dialog Configuration for ObjectType '" + objecttype + "' not found.";
  }
}

export class WizardConfigurationNotFoundError implements Error {
  name = 'View.WizardConfigurationNotFoundError';
  message = '6 | Wizard Configuration not found.';

  constructor(private urlid: string) {
    this.message = "6 | Wizard Configuration for URLID '" + urlid + "' not found.";
  }
}
